import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, normalizeClass as _normalizeClass, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-24c5e462"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "TTNListItem" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_the_button = _resolveComponent("the-button")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("span", null, _toDisplayString(_ctx.item.receiver_city), 1),
    _createVNode(_component_the_button, {
      loading: _ctx.state.is_loading,
      disabled: _ctx.state.is_delivered || _ctx.item.delivered_at,
      class: _normalizeClass([{ green: _ctx.state.is_delivered, primary: !_ctx.state.is_delivered }, "small"]),
      onClick: _ctx.onClick
    }, {
      default: _withCtx(() => [
        _createTextVNode(" Доставлено ")
      ]),
      _: 1
    }, 8, ["loading", "disabled", "class", "onClick"])
  ]))
}